/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SimpleMissingView from 'Simple/MissingView'

function TysiaV2EmailIcon() {
  return (
    <SimpleMissingView
      pointOfUseViewId="Email"
      pointOfUseFile="/home/circleci/project/apps/admin/src/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Emails/Content/Email/view.blocks"
      targetViewId="TysiaV2EmailIcon"
      targetFileAtPointOfUse="/home/circleci/project/apps/admin/src/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Emails/Content/Email/TysiaV2EmailIcon/view.blocks"
      targetFileAtDesignSystem="/home/circleci/project/apps/admin/src/DesignSystem/TysiaV2EmailIcon/view.blocks"
    />
  )
}
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Emails/Content/Email"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let emailAddressValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'address',
})
  return (<React.Fragment
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaV2EmailIcon
  viewPath={`${viewPath}/TysiaV2EmailIcon`}
 height={18}
 width={18}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="email.address"
 text={emailAddressValueData}
/>
</div>
{children}
</React.Fragment>)
}